export default "__VITE_ASSET__B00RRupX__"